<template>
  <div class="shopdetailApp" :style="'height:'+curHeight+'px;background:url('+bg+') no-repeat;background-size:100% 100% !important;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="shop">
      <div class="title">北海红树林菜园店家</div>
      <img src="http://admin.4008005216.com//upload/20210617/8e59c304c40c343643b091857b341982.jpg" />
      <div style="clear:both"></div>
      <p>红树林是热带、亚热带海岸潮间带特有的胎生木本植物群落，素有"海上森林"之称，幽秘神奇、倚海而生，随潮涨而隐、潮退而现，是国家级重点保护的珍稀植物。北海山口镇的国家级红树林自然保护区位于广西北海市合浦县境内，海岸线长50公里，面积8000公顷，光热充足，港湾深入内陆，封闭好，海水污染程度低，理化性质稳定，滩涂淤泥肥沃，适宜于红树林生长，保护红树林面积为7.2平方公里，共有红海榄树、秋茄、桐花树等12种红树林植物，是广西乃至全国大陆海岸发育良好，连片大，结构较典型，保护较完整的红树林区。</p>
    </div>

    <div class="product">
      <h2>产品</h2>
      <ul>
        <li>
          <img src="https://ss2.baidu.com/6ONYsjip0QIZ8tyhnq/it/u=3136077011,1681309265&fm=199&app=68&f=JPEG?w=375&h=375&s=1C924A97CAFBF6CE5A0A4AAE0300A00F" />
          <div class="right">
            <h3>最甜火龙果五斤装（红心包邮）</h3>
            <p>
              <font>月售：36</font>
            </p>
            <div class="price">
              <i><b>¥</b> 18.<b>00</b></i>
              <span>38.00</span>
            </div>
          </div>
          <a>立即购买</a>
        </li>
        <li>
          <img src="https://ss2.baidu.com/6ONYsjip0QIZ8tyhnq/it/u=3136077011,1681309265&fm=199&app=68&f=JPEG?w=375&h=375&s=1C924A97CAFBF6CE5A0A4AAE0300A00F" />
          <div class="right">
            <h3>最甜火龙果十斤装（红心包邮）</h3>
            <p>
              <font>月售：6</font>
            </p>
            <div class="price">
              <i><b>¥</b> 28.<b>00</b></i>
              <span>38.00</span>
            </div>
          </div>
          <a>立即购买</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        code:'',
        bg:require('../../assets/images/farm.png'),
      };
    },

    beforeMount() {
      if(localStorage.getItem('user') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/farm');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('user'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('user') == null){
        this.login();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('user', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .shopdetailApp{
    max-width:640px;
    margin:0 auto;
    background-size: 100% 100%;
    overflow-y: scroll;
  }
  .shopdetailApp .shop{
    background:rgba(255,255,255,.8);
    display:block;
    padding:5%
  }
  .shopdetailApp .shop .title{
    float:left;
    width:78%;
    font-weight: bold;
    color: #333333;
    font-size:16px;
    letter-spacing: 1px;
    line-height:23px;
  }
  .shopdetailApp .shop img{
    float:left;
    width:20%;
    margin-left:2%;
    border-radius: 6px;
  }
  .shopdetailApp .shop p{
    font-size: 15px;
    color: #666666;
    letter-spacing: 1px;
    line-height:23px;
    padding-top:10px
  }

  .shopdetailApp .product{
    min-height:600px;
    background:rgba(255,255,255,.8);
    margin-top:10px
  }
  .shopdetailApp .product h2{
    width:92%;
    display:block;
    margin:0 auto;
    padding:15px 0;
    color: #333333;
    font-size:16px
  }

  .shopdetailApp .product li{
    width:92%;
    display:block;
    margin:0 auto;
    border-radius: 10px;
    padding:3%;
    position: relative;
    border-bottom:solid 1px #EEEEEE;
  }
  .shopdetailApp .product li:last-child{
    border:0
  }
  .shopdetailApp .product li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }

  .shopdetailApp .product li img{
    float:left;
    width:30%;
    border-radius: 8px;
  }
  .shopdetailApp .product li .right{
    float:left;
    width:70%
  }
  .shopdetailApp .product li .right h3{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: #333333;
    font-size:15px;
    padding-left:8px
  }
  .shopdetailApp .product li .right p{
    padding-left:8px;
    padding-top:12px;
  }
  .shopdetailApp .product li .right p font{
    font-size: 15px;
    color: #999999;
  }

  .shopdetailApp .product li .right .price{
    padding-top:15px;
    padding-left:6px
  }
  .shopdetailApp .product li .right .price span{
    text-decoration: line-through;
    color:#999;
    font-size:14px;
    padding-left:10px;
  }


  .shopdetailApp .product li .right .price i{
    color: #FF1E00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .shopdetailApp .product li .right .price b{
    font-size:12px;
  }

  .shopdetailApp .product li a{
    position: absolute;
    right:4%;
    bottom:10px;
    width: 80px;
    height: 30px;
    background: #00D138;
    border-radius: 10px;
    color:#fff;
    font-size:15px;
    text-align:center;
    line-height: 30px;
  }

  
</style>